/**
 * Created by denis.gusarov on 3/10/2017.
 */

namespace Factive.Game {

    import Tween = Factive.Core.Tween.Tween;
    import Easing = Factive.Core.Tween.Easing;
    import List = Factive.Core.Linq.List;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import _ = Factive.Core.Underscore;
    import ArenaHelper = Arkadium.Game.ArenaHelper;
    import EventBus = Factive.Core.EventBus;
    import AnalyticsManager = Arkadium.Core.AnalyticsManager;
    import LocalizationManager = Arkadium.Core.utils.LocalizationManager;
    import StorageManager = Factive.Core.StorageManager;
    import StorageManagerConstants = Factive.Core.StorageManagerConstants;
    import Howler2SoundManager = Factive.Core.Howler2SoundManager;
    import Howler1SoundManager = Factive.Core.Howler1SoundManager;
    import ISoundManager = Factive.Core.ISoundManager;
    import GameAutoTestingManager = Arkadium.Game.GameAutoTestingManager;
    import LocalizationConstants = Arkadium.Game.Localization.LocalizationConstants;


    export class GameSize {

        public callback: () => void;

        public get x(): number {
            if (this.callback) {
                this.callback();
            }
            return this._x;
        }

        public set x(value: number) {
            if (this.callback) {
                this.callback();
            }
            this._x = value;
        }

        public get y(): number {
            if (this.callback) {
                this.callback();
            }
            return this._y;
        }

        public set y(value: number) {
            if (this.callback) {
                this.callback();
            }
            this._y = value;
        }

        public constructor(private _x: number, private _y: number, private _s?: number) {

        }
    }

    export abstract class GameBase {
        protected static _initialized = false;
        protected _container: PIXI.Container;
        protected _width: number;
        protected _height: number;
        protected _scaleFactor: number = 1;
        //protected _app: PIXI.Application;
        public _stage: PIXI.Container;
        protected _layers:Array<PIXI.Container> = [];
        protected _aspectRatio:string;
        public renderer: PIXI.WebGLRenderer;
        private renderer3d: THREE.WebGLRenderer;
        private _diceRenderer: Factive.Game.DiceRendererClass;
        private _clientWidth: number;
        private _clientHeight: number;

        public get width(): number {
            return this._width * this.scaleFactor;
        }

        public get height(): number {
            return this._height * this.scaleFactor;
        }

        public get scaleFactor(): number {
            return this._scaleFactor;
        }

        private _size: GameSize = new GameSize(640, 480, 1);
        private config: any;

        protected $childViews: ChildViews = new ChildViews();

        /* public set Size(value: GameSize) {
         this._size = value;
         }


         public get Size(): GameSize {
         return this._size;
         };*/

        public constructor(protected dc: DependenciesContainer,
                           private _htmlElement: HTMLElement) {
            let assetScale:number = this.defineAssetScale();
            this.dc.singleton("AssetScale",assetScale);

            this._scaleFactor = assetScale;

        };

        protected abstract getConfiguration(): any;

        protected abstract onInitialize(): void;

        protected abstract onSetLandscape(): void;

        protected abstract onSetPortrait(): void;

        // protected abstract onUpdate(): void;

        protected abstract onCreate(): void;

        protected load(callback: () => void, viewBase: ViewBase = null): void {

            if (PIXI.loader.loading) {
                PIXI.loader.once("complete", () =>
                {
                    this.load(callback)
                }, this);
                return;
            }

            let needLoad = false;
            let resourcesRoot = this.dc.get("ResourcesRoot");

            if(!viewBase){
                let resources = new List<ResourceItem>();
                this.$childViews.items.ForEach(ch => {
                    resources.AddRange(ch.view.getResources());
                });
                resources.ForEach((res, i) => {
                    if(!PIXI.loader.resources[res.name]) {
                        needLoad = true;
                        PIXI.loader.add(res.name, resourcesRoot + res.res);
                    }
                });
            }else{
                let resources = new List<ResourceItem>();
                resources.AddRange(viewBase.getResources());
                resources.ForEach((res, i) => {
                    if(!PIXI.loader.resources[res.name]) {
                        needLoad = true;
                        PIXI.loader.add(res.name, resourcesRoot + res.res);
                    }else{
                        if(PIXI.loader.resources[res.name].type == PIXI.loaders.Resource.TYPE.IMAGE
                            && PIXI.loader.resources[res.name].texture.baseTexture == null){
                            needLoad = true;
                            PIXI.loader.resources[res.name] = null;
                            PIXI.loader.add(res.name, resourcesRoot + res.res);
                        }
                    }
                });
            }

            if (needLoad) {
                PIXI.loader.once("complete", () => {
                    callback();
                }, this);
                PIXI.loader.load();
            } else {
                callback();
            }
        }

        protected configure() {
            this.config = this.getConfiguration();
        }

        protected initialize()
        {
            _.each(this.config.childViews, function (child, key) {
                if (child.view) {
                    let view = this.dc.get(child.view, child.options);
                    if (view) {
                        view.configure();
                        let childItem = new ChildItem(view);
                        childItem.name = key;
                        childItem.viewName = child.view;
                        this.$childViews.items.Add(childItem);
                        this.$childViews[key] = childItem;
                        childItem.view.initialize(null, this._container);
                    }
                }
            }, this);

            this.onInitialize();

            this.load(() => {
                this.contentLoaded();
            });
        }

        public create(): any {

            //console.log("GAME BASE CREATE");

            let that = this;
            that.initializeManagers();

            let resourcesRoot = this.dc.get("ResourcesRoot");
            const cdnUrl = that.dc.get("ArenaHelper").getAbsoluteURL("");

            let fontsCss = this.dc.get("main/fonts").split("%RESOURCEPATH%").join(cdnUrl + resourcesRoot),
                head = document.head || document.getElementsByTagName('head')[0],
                style = <any>document.createElement('style');
            style.type = 'text/css';
            if (style.styleSheet){
                style.styleSheet.cssText = fontsCss;
            } else {
                style.appendChild(document.createTextNode(fontsCss));
            }
            head.appendChild(style);

            let fontFaceObserver = this.dc.get("FontFaceObserver");

            let font1 = fontFaceObserver.create('Regular');
            let font2 = fontFaceObserver.create('Medium');
            let font3 = fontFaceObserver.create('Bold');

            let assetScale:number = this.dc.get("AssetScale");
            //console.log("assetScale",assetScale);

            //that.initializeManagers();

            return new Promise(function (resolve, reject) {

                return Promise.all([
                    font2.load(),
                    that.loadIntro(),
                ]).then(function () {
                        let webGlError:boolean = that.createPixiApplication();
                        if(!webGlError)
                        {
                            that.createIntro();
                        }
                        else
                        {
                            return Promise.all([
                                that.loadLocalization().then(() => {
                                    //console.log("load localization");
                                    return true;})
                            ]).then(function () {
                                    let lm:LocalizationManager = that.dc.get("LocalizationManager");
                                    let message:string = lm.getText(LocalizationConstants.NOT_SUPPORTING_WEBGL_MESSAGE);
                                    const regExp:RegExp = /%LINE_BREAK%/gi;
                                    message = message.replace(regExp, "\n");

                                    let pixiText = new PIXI.Text(message);
                                    pixiText.style.fontSize = 24 * assetScale;
                                    pixiText.style.fill = '#FFFFFF';
                                    pixiText.style.align = 'center';
                                    pixiText.style.wordWrap = true;
                                    pixiText.style.wordWrapWidth = 400 * assetScale;
                                    pixiText.x = -pixiText.width * 0.5;
                                    pixiText.y = -pixiText.height * 0.5;
                                    that._container.addChild(pixiText);

                                    setTimeout(() => {
                                        resolve(that);
                                    }, 500);
                                },
                                function (error) {

                                });
                        }

                        return Promise.all([
                            font1.load().then(() => {
                                //console.log("load font1");
                                return that.incLoadIndex();}),
                            font3.load().then(() => {
                                //console.log("load font2");
                                return that.incLoadIndex();}),
                            that.loadLocalization().then(() => {
                                //console.log("load localization");
                                return that.incLoadIndex();}),
                            Factive.Game.Resources.load(cdnUrl + resourcesRoot,assetScale).then(() => {
                                //console.log("load assets");
                                return that.incLoadIndex();}),
                            that.loadingSounds().then(() => {
                                //console.log("load sounds");
                                return that.incLoadIndex();})
                        ]).then(function () {

                                that.continueInitialize();
                                setTimeout(() => {
                                    resolve(that);
                                }, 500);
                            },
                            function (error) {

                        });
                },
                function (error) {

                });

            });
        }

        //------------------------------

        protected initializeManagers():void {
            let lm: LocalizationManager = new LocalizationManager();
            this.dc.singleton("LocalizationManager", lm);

            let eb:EventBus= new EventBus();
            this.dc.singleton("EventBus",eb);

            let ah:ArenaHelper = new ArenaHelper(this.dc);
            this.dc.singleton("ArenaHelper",ah);

            let at:GameAutoTestingManager = new GameAutoTestingManager(this, this.dc);
            this.dc.singleton("GameAutoTestingManager",at);

            let resourcesRoot = this.dc.get("ResourcesRoot");
            const cdnUrl = this.dc.get("ArenaHelper").getAbsoluteURL("");
            let sm:ISoundManager; // TODO Use set volume when start play sound (now volume 0 or 1 when we use mute on/off)

            if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)))
            {
                sm = new Howler1SoundManager(this.dc.get("HowlConstructor"),this.dc.get("soundConfig"), cdnUrl + resourcesRoot);
                this.dc.singleton("SoundManager",sm);
            }
            else
            {
                sm = new Howler2SoundManager(this.dc.get("HowlerSound"), this.dc.get("Howler"), this.dc.get("soundConfig"), cdnUrl + resourcesRoot);
                this.dc.singleton("SoundManager",sm);
            }

            let an:AnalyticsManager = new AnalyticsManager();
            an.init({
                //Disabling Google Analytics due to potential GDPR issue
            //    provider:AnalyticsManager.Providers.GOOGLE,
            //    google: { gaId: "G-MQP5C5JQ3B"}
            });
            this.dc.singleton("AnalyticsManager",an);

            let anH:AnalyticsHelper = new AnalyticsHelper(this.dc);
            this.dc.singleton("AnalyticsHelper",anH);

            let ls:StorageManager = new StorageManager();
            ls.initialize("five-roll");
            this.dc.singleton("StorageManager",ls);

            let mute:boolean = ls.loadData(StorageManagerConstants.MUTE_SOUNDS) == "1";
            sm.mute(mute);
        };

        protected loadLocalization():any{
            let that = this;

            const cdnUrl = that.dc.get("ArenaHelper").getAbsoluteURL("");

            return new Promise(function (resolve, reject) {
                var lm:LocalizationManager = that.dc.get("LocalizationManager");
                let localization = that.dc.get("Localization");
                let arenaHelper = that.dc.get("ArenaHelper");

                lm.signal.add(() => {
                    resolve();
                },that);
                lm.initialize(cdnUrl, arenaHelper.getLocale());
            });
            //
        };

        protected loadingSounds():any {
            let that = this;

            return new Promise(function (resolve, reject) {
                let sm = that.dc.get("SoundManager");

                if (navigator.appName == 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)))
                {
                    sm.load("sfx");
                    //sm.playSound(SoundConstants.BG_MUSIC, true);

                    resolve();
                }
                else{
                    sm.preloadAudio((loaded, length) =>{
                    }, () => {
                        //sm.playSound(SoundConstants.BG_MUSIC, true);
                    }, "sfx");

                    resolve();
                }
            });
        }

        protected loadIntro():any
        {
            let that = this;

            return new Promise(function (resolve, reject) {
                const cdnUrl = that.dc.get("ArenaHelper").getAbsoluteURL("");

                // PIXI.loader.add ("introscreen_ske","build/resources/assets/images/"+that.dc.get("AssetScale").toString()+"x/introscreen_ske.json");
                // PIXI.loader.add ("introscreen_tex_config","build/resources/assets/images/"+that.dc.get("AssetScale").toString()+"x/introscreen_tex.json");
                PIXI.loader.add ("introscreen_tex_png", cdnUrl + "build/resources/assets/images/"+that.dc.get("AssetScale").toString()+"x/introscreen_tex.png");

                PIXI.loader.load();

                PIXI.loader.once("complete", (loader:any,resources:any) => {
                    let introscreen_ske, introscreen_tex;
                    if(that.dc.get("AssetScale") === 1){
                        introscreen_ske = that.dc.get("Introscreen1xSke");
                        introscreen_tex = that.dc.get("Introscreen1xTex");
                    }else{
                        introscreen_ske = that.dc.get("Introscreen2xSke");
                        introscreen_tex = that.dc.get("Introscreen2xTex");
                    }

                    dragonBones.PixiFactory.factory.parseTextureAtlasData(introscreen_tex, resources["introscreen_tex_png"].texture);
                    dragonBones.PixiFactory.factory.parseDragonBonesData(introscreen_ske);

                    // dragonBones.PixiFactory.factory.parseTextureAtlasData(resources["introscreen_tex_config"].data, resources["introscreen_tex_png"].texture);
                    // dragonBones.PixiFactory.factory.parseDragonBonesData(resources["introscreen_ske"].data);

                    resolve();
                }, that);
            });
        };

        protected abstract createIntro(): void;

        protected abstract onIncLoadIndex(): void;

        protected incLoadIndex(): any {
            this.onIncLoadIndex();
            return Promise.resolve();
        }

        //------------------------------

        private continueInitialize(): void
        {
            this.onCreate();
            this.configure();
            this.initialize();
        };

        _addWindowListeners():void{
            let hidden = "hidden";
            let that = this;

            // Standards:
            if (typeof document.mozHidden != "undefined")
            {
                hidden = "mozHidden";
                document.addEventListener("mozvisibilitychange", onchange);
            }
            else if (typeof document.webkitHidden != "undefined")
            {
                hidden = "webkitHidden";
                document.addEventListener("webkitvisibilitychange", onchange);
            }
            else if (typeof document.msHidden != "undefined")
            {
                hidden = "msHidden";
                document.addEventListener("msvisibilitychange", onchange);
            }
            else if (typeof document.hidden != "undefined")
            {
                document.addEventListener("visibilitychange", onchange);
            }

            // IE 9 and lower:
            else if ("onfocusin" in document)
                document.onfocusin = document.onfocusout = onchange;
            // All others:
            //else
                window.onpageshow = window.onpagehide = window.onfocus = window.onblur = onchange;

            function onchange(evt) {
                var v = "visible",
                    h = "hidden",
                    evtMap = {
                        focus: v,
                        focusin: v,
                        pageshow: v,
                        blur: h,
                        focusout: h,
                        pagehide: h
                    };

                evt = evt || window.event;
                if (evt.type in evtMap) {
                    if(evtMap[evt.type] == "hidden"){

                    }else{
                        that.rendererResize(true);
                    }
                } else {
                    if(document[hidden]){

                    }else{
                        that.rendererResize(true);
                    }
                }
            }

            // set the initial state (but only if browser supports the Page Visibility API)
            if (document[hidden] !== undefined)
                onchange({
                    type: document[hidden] ? "blur" : "focus"
            });
        }

        protected createPixiApplication(): boolean
        {
            // let noWebGL = false;
            // if (navigator.userAgent.match(/iemobile/i) || navigator.userAgent.match(/Windows Phone/i)) {
            //     noWebGL = true;
            // }

            this._htmlElement.style.display = 'none';

            let md = this.dc.get("MobileDetect");
            let options = <PIXI.RendererOptions>{
                backgroundColor : 0x255B66
            };

            if(!!md.phone() == false
                && !!md.tablet() == false
                && !!md.mobile() == false){
                options.antialias = true;
            }

            options.antialias = true;

            if(md.os() == "AndroidOS"){
                let versionAndroid = md.version("Android");
                if(versionAndroid && Math.floor(versionAndroid) <= 4)
                {
                    options.preserveDrawingBuffer=true;
                }
            }

            //this.renderer = <PIXI.WebGLRenderer> PIXI.autoDetectRenderer(640, 480, options, true); // only canvas
            this.renderer = <PIXI.WebGLRenderer> PIXI.autoDetectRenderer(640, 480, options);

            this._stage = new PIXI.Container();

            this._htmlElement.appendChild(<any>this.renderer.view);

            //this.renderer.view.classList.add("interactive");
            //this.renderer.view.style['touch-action'] = 'auto';
            //this.renderer.view.style['-webkit-touch-callout'] = 'none';
            this.renderer.view.style['-webkit-user-select'] = 'none';
            this.renderer.view.style['-khtml-user-select'] = 'none';
            this.renderer.view.style['-moz-user-select'] = 'none';
            this.renderer.view.style['-ms-user-select'] = 'none';
            this.renderer.view.style['user-select'] = 'none';
            this.renderer.view.style['outline'] = 'none';
            this.renderer.view.style['-webkit-tap-highlight-color'] = 'rgba(255, 255, 255, 0)';
            //this.renderer.plugins.interaction.autoPreventDefault = false;

            this._container = new PIXI.Container();
            let numLayers:number = 5;
            for(let i:number = 0; i < numLayers; i++)
            {
                let sp:PIXI.Container = new PIXI.Container();
                this._layers[i] = sp;
                this._container.addChild(sp);
            }

            this._stage.addChild(this._container);

            //window.addEventListener('resize', ()=>{this.resize();});
            window.addEventListener('deviceOrientation', ()=>{this.rendererResize();});

            this._htmlElement.style.display = 'block';

            let webGlError = false;
            let threeJsEnabled = !!(<any>window).THREE;
            if (threeJsEnabled){

                let context = this.renderer.view.getContext("webgl") || this.renderer.view.getContext("experimental-webgl");
                if (context && context instanceof  WebGLRenderingContext) {
                    // browser supports WebGL but initialization failed.
                    //window.location = "http://get.webgl.org/troubleshooting";
                    webGlError = false;
                }
                else {
                    webGlError = true;
                }

                if(!webGlError)
                {
                    // this.renderer3d = new THREE.WebGLRenderer(<any>{ canvas: this.renderer.view, context: this.renderer.gl, antialias: true });
                    this.renderer3d = new THREE.WebGLRenderer({canvas:this.renderer.view, context:this.renderer.gl});
                    this.renderer3d.autoClear = false;

                    this._diceRenderer = new DiceRendererClass(this._scaleFactor, this._aspectRatio, this.renderer3d, this.renderer.gl);

                    if(md.tablet() == "iPad"){
                        this._addWindowListeners();
                    }

                    this.dc.singleton("DiceRenderer",this._diceRenderer);
                }

                this.rendererResize(true);

                this.running = (new Date()).getTime();
                this.last_time = 0;
                this.animate(this.running);
            }

            return webGlError;
        }

        private running: number;
        private last_time: number;

        animate(threadId) {

            if(this._clientWidth != this._htmlElement.clientWidth || this._clientHeight != this._htmlElement.clientHeight){
                this.resize();
            }

            let frame_rate = 1/60;
            let time = (new Date()).getTime();
            let time_diff = (time - this.last_time) / 1000;
            if (time_diff > 3) time_diff = frame_rate;

            do
            {
                dragonBones.WorldClock.clock.advanceTime(-1);
                Tween.update();
                if(this._diceRenderer){
                    this._diceRenderer.animate(frame_rate);
                }

                time_diff -= frame_rate;
            } while (time_diff > frame_rate * 1.1);

            this.last_time = this.last_time ? time : (new Date()).getTime();

            if(this._diceRenderer)
            {
                this.renderer.gl.disable(this.renderer.gl.DEPTH_TEST);
                this.renderer.gl.disable(this.renderer.gl.CULL_FACE);
                this.renderer.gl.enable(this.renderer.gl.BLEND);
                this.renderer.gl.blendFunc(this.renderer.gl.ONE, this.renderer.gl.ONE_MINUS_SRC_ALPHA);
                //this.renderer.gl.viewport(0, 0, this.renderer.gl.canvas.width, this.renderer.gl.canvas.height);
            }

            this.renderer.render(this._stage);

            if (this.running == threadId){
                if (time_diff < frame_rate) {
                    setTimeout(() =>
                        {
                            requestAnimationFrame(() =>
                            {
                                this.animate(threadId);
                            });
                        },
                        (frame_rate - time_diff) * 1000);
                } else {
                    requestAnimationFrame(() =>
                    {
                        this.animate(threadId);
                    });
                }
            }
        }

        rendererResize(force = false): void
        {
            if(this._clientWidth == this._htmlElement.clientWidth
                && this._clientHeight == this._htmlElement.clientHeight
                && force == false){
                return;
            }
            this._clientWidth = this._htmlElement.clientWidth;
            this._clientHeight = this._htmlElement.clientHeight;

            let devicePixelRatio = this.dc.get("DevicePixelRatio");

            let width = this._clientWidth * devicePixelRatio;
            let height = this._clientHeight * devicePixelRatio;

            let canvas = this.renderer.view;

            this.renderer.resize(width,height);
            if( this._diceRenderer)
            {
                this._diceRenderer.resize(width,height);
            }

            canvas.style.width = this._clientWidth + 'px';
            canvas.style.height = this._clientHeight + 'px';

            if (width*1.1 < height)
            {
                this.setPortrait();
            }
            else
            {
                this.setLandscape();
            }
        }

        protected setPortrait() {


            this._size.y = 800;
            this._size.x = 480;


            let sc:number = Math.min(this.renderer.view.height / (this._size.y* this.scaleFactor),this.renderer.view.width / (this._size.x* this.scaleFactor)) ;
            let l:number = this._layers.length;

            for (let i:number = 0; i < l; i++)
            {
                if(i!=0)
                {
                    //0 - background
                    //1 - game
                    //2 - panels
                    //3 - intro
                    this._layers[i].scale.x = this._layers[i].scale.y = sc;
                }
            }

            this._container.x = this.renderer.view.width *.5;
            this._container.y = this.renderer.view.height *.5;

            this.onSetPortrait();
            this.$childViews.items.ForEach(ch => {
                ch.view.setPortrait();
            });
        }

        protected setLandscape() {

            this._size.y = 480;
            this._size.x = 640;

            let sc:number = Math.min(this.renderer.view.height / (this._size.y* this.scaleFactor),this.renderer.view.width / (this._size.x* this.scaleFactor)) ;

            let l:number = this._layers.length;
            for (let i:number = 1; i < l; i++)
            {
                this._layers[i].scale.x = this._layers[i].scale.y = sc;
            }

            this._container.x = this.renderer.view.width *.5;
            this._container.y = this.renderer.view.height *.5;

            this.onSetLandscape();

            this.$childViews.items.ForEach(ch => {
                ch.view.setLandscape();
            });
        }

        protected clear(){
            this.$childViews.items.ForEach(ch => {
                ch.view.dispose();
            });
            this.$childViews = new ChildViews()
        }

        private _resizeDelay = {d:2};
        private _tweenResizeDelay = new Tween(this._resizeDelay)
            .to({d: 0}, 500)
            .easing(Easing.Linear.None)
            .onComplete(() => {
                this.rendererResize();
                this._resizeDelay.d = 2;
            });
        protected resize()
        {
            if(this._resizeDelay.d < 2){
                return;
            }
            this._tweenResizeDelay.start();
        }

        public getLayer(level:number):PIXI.Container
        {
            if(!this._layers || level>=this._layers.length)
            {
                return null
            }
            return this._layers[level];
        }

        protected contentLoaded() {
            this.onContentLoaded();
            // this.$childViews.items.ForEach(ch => {
            //     ch.view.contentLoaded();
            // });
        }

        protected onContentLoaded() {

        }

        // protected onPIXIApplicationCreated():void
        // {
        //
        // }

        private defineAssetScale() {

            let devicePixelRatio = this.dc.get("DevicePixelRatio");

            let width = window.innerWidth * devicePixelRatio;
            let height = window.innerHeight * devicePixelRatio;

            let maxSideLength = Math.max(width, height);
            if (maxSideLength < 950)
            {
                return 1;
            }
            else
            {
                return 2;

            }
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Base/GameBase.ts